export const FORGOT_PASSWORD_URL = 'forgot_password/submit'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD_LOADING = 'FORGOT_PASSWORD_LOADING'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'

export const RESET_PASSWORD_URL = 'forgot_password/reset'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
export const RESET_PASSWORD_LOADING = 'RESET_PASSWORD_LOADING'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'